import { Injectable } from '@angular/core';

import { AdvertSearchResult } from '../models/advert.model';

@Injectable()
export class FilterSearchService {

    sortResultByPublishDate(searchResult: AdvertSearchResult[]): AdvertSearchResult[] {
        searchResult.sort((result1: AdvertSearchResult, result2: AdvertSearchResult) =>
            new Date(result2.PublishDate).getTime() - new Date(result1.PublishDate).getTime());
        return searchResult;
    }

    sortResultByRelevance(searchResult: AdvertSearchResult[]): AdvertSearchResult[] {
        searchResult.sort((result1: AdvertSearchResult, result2: AdvertSearchResult) =>
            result2.Score - result1.Score);
        return searchResult;
    }

    sortResultByClosingDate(searchResult: AdvertSearchResult[]): AdvertSearchResult[] {
        searchResult.sort((result1: AdvertSearchResult, result2: AdvertSearchResult) =>
            new Date(result1.ClosingDate).getTime() - new Date(result2.ClosingDate).getTime());
        return searchResult;
    }

    sortResultByDistance(searchResult: AdvertSearchResult[]): AdvertSearchResult[] {
        searchResult.sort((result1: AdvertSearchResult, result2: AdvertSearchResult) =>
            result1.GeoDistance - result2.GeoDistance);
        return searchResult;
    }
}
